import { render } from "./UserMenu.vue?vue&type=template&id=408a5d9a&scoped=true&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=408a5d9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408a5d9a"]])

export default __exports__